import { useState, useEffect } from 'react';
import axios from 'axios';
import * as appConstants from "../../../constants/index";
import SweetAlertUtility from './SweetAlertUtility';
import { useNavigate } from 'react-router-dom';

const ApplyOffers = ({ offer, applyOfferApi, payDetailLoading }) => {
    const navigate = useNavigate();

    const [loading, setLoading] = useState(false);
    const [alertDetails, setAlertDetails] = useState({
        show: false,
        type: '',
        title: '',
        message: ''
    });

    const userInfoData = JSON.parse(sessionStorage.getItem("loginInfo"));
    const seatdetails = JSON.parse(localStorage.getItem("seatdetails"));
    const theatreId = localStorage.getItem("TheatreId");
    const cardDetailsData = JSON.parse(localStorage.getItem("cardDetails"));
    const transactionType = localStorage.getItem("TransactionType");
    const bookingId = localStorage.getItem("bookingid") || "";
    const transId = localStorage.getItem("transid") || "";
    const authToken = "Bearer " + sessionStorage.getItem("token");

    // ✅ Show error alert
    const sweetAlertError = (msg) => {
        setAlertDetails({
            show: true,
            type: "error",
            title: "Error!",
            message: msg,
        });
    };

    // ✅ Hide alert
    const hideAlert = () => {
        setAlertDetails({ show: false, type: '', title: '', message: '' });
    };

    // ✅ API call logic
    const getApplyData = async (vouId, vouDesc, vouType, category, type, tnc) => {
        setLoading(true);
        try {
            const voutypedata =
                vouType?.toLowerCase() === 'auto'
                    ? 'AUTOVOUCHER'
                    : vouType?.toLowerCase() === 'binbased'
                        ? 'BANKOFFER'
                        : vouType?.toLowerCase() === 'promocode'
                            ? 'PROMOCODE'
                            : 'AUTOVOUCHER';

            const unlockData = vouType?.toLowerCase() === 'auto' ? false : '';
            const cardData = vouType?.toLowerCase() === 'binbased' ? cardDetailsData?.cardNumber : '';
            const cardTypeData = vouType?.toLowerCase() === 'binbased' ? cardDetailsData?.cardType : '';
            const vouIdData = vouType?.toLowerCase() === 'promocode' ? 0 : vouId;
            const fnb_qrData = seatdetails?.fnb_qr === 'YES' || transactionType === 'InCinemaFB' ? 'YES' : 'NO';
            const qrsData = fnb_qrData === 'YES';

            const formData = {
                ccode: theatreId || '',
                bookingId: bookingId || '',
                transId: transId || '',
                bookType: 'FOOD',
                couponId: vouIdData,
                coupon: vouId,
                couponType: voutypedata || '',
                qr: fnb_qrData,
                card: cardData || '',
                cardType: cardTypeData || '',
                mobile: userInfoData?.data?.mob || '',
                otp: '',
                unlock: unlockData,
                qrs: qrsData,
            };

            const state = { ...formData, tnc };

            // Navigate if certain conditions match
            if (
                category?.toLowerCase() === 'offer' &&
                type?.toLowerCase() === 'bank' &&
                vouType?.toLowerCase() === 'binbased'
            ) {
                const nameURL = encodeURIComponent(vouDesc.replace(/\s+/g, '-').toLowerCase());
                navigate(`/bankoffer/${nameURL}`, { state: { bankCurrentDataState: state } });
                return;
            }

            if (
                category?.toLowerCase() === 'voucher' &&
                type?.toLowerCase() === 'normal' &&
                vouType?.toLowerCase() === ''
            ) {
                navigate(`/promocode`, { state: { promoCodeState: state } });
                return;
            }

            // API call
            const response = await axios.post(
                `${appConstants.base_url}v1/payment/coupon/apply`,
                formData,
                {
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: authToken,
                        chain: localStorage.getItem('theme') === 'inoxTheme' ? 'INOX' : 'PVR',
                        appVersion: appConstants.av,
                        platform: appConstants.pt,
                        country: appConstants.cname,
                    },
                }
            );

            if (response?.data.result === 'success') {
                const appliedOfferData = {
                    vouDesc,
                    vouId,
                    resOffer: response.data,
                    vouPayType: voutypedata,
                };

                localStorage.setItem('AppliedOfferData', JSON.stringify(appliedOfferData));

                const existGetAllFnbData = JSON.parse(localStorage.getItem('getAllFnbData') || '{}');
                existGetAllFnbData.AppliedOfferDataNew = appliedOfferData;
                appliedOfferData.ApplyOfferRespn = response?.data;
                localStorage.setItem('getAllFnbData', JSON.stringify(existGetAllFnbData));
            } else {
                sweetAlertError(response.data.msg);
            }
        } catch (error) {
            sweetAlertError('Something went wrong!');
            console.error('Error details:', error.response ? error.response.data : error.message);
        } finally {
            setLoading(false);
        }
    };

    // Example: auto-run when `offer` prop changes
    useEffect(() => {
       // debugger
        if (offer?.vouId) {
            getApplyData(offer.vouId, offer.vouDesc, offer.vouType, offer.category, offer.type, offer.tnc);
        }
    }, [offer]);

    // ✅ Render
    return (
        <>
            <div className="prcwrth appliedOffer">
                <div className="aplylist">
                    <svg className='chckIcon' width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M7.23039 0.597215C8.16472 -0.199069 9.53906 -0.199077 10.4735 0.597223L11.5968 1.55451C11.7302 1.66826 11.8961 1.73698 12.071 1.75093L13.5422 1.86834C14.766 1.96599 15.7378 2.9378 15.8355 4.16156L15.9529 5.63279C15.9668 5.80758 16.0355 5.97353 16.1492 6.10701L17.1066 7.23038C17.9029 8.16471 17.9029 9.53905 17.1066 10.4735L16.1492 11.5967C16.0356 11.7302 15.9667 11.8962 15.9528 12.071L15.8355 13.5422C15.7378 14.766 14.766 15.7378 13.5422 15.8354L12.071 15.9528C11.8961 15.9668 11.7302 16.0355 11.5968 16.1493L10.4735 17.1065C9.53906 17.9029 8.16472 17.9028 7.23031 17.1065L6.10698 16.1493C5.97352 16.0355 5.8076 15.9668 5.63281 15.9529L4.16159 15.8354C2.93781 15.7377 1.96602 14.766 1.86837 13.5422L1.75094 12.071C1.73699 11.8962 1.66825 11.7303 1.55452 11.5968L0.597224 10.4734C-0.199068 9.53905 -0.199076 8.1648 0.597207 7.23038L1.55451 6.10704C1.66825 5.97357 1.73701 5.80758 1.75095 5.63278L1.86836 4.16155C1.96601 2.93778 2.93778 1.96601 4.16156 1.86835L5.6328 1.75094C5.8076 1.73699 5.97355 1.66826 6.10702 1.55451L7.23039 0.597215ZM9.39239 1.86573C9.08097 1.60031 8.62281 1.60031 8.31139 1.86573L7.18806 2.82304C6.78764 3.16426 6.28979 3.37047 5.76537 3.41232L4.29414 3.52973C3.88622 3.56229 3.56229 3.88621 3.52974 4.29414L3.41232 5.76541C3.37047 6.28981 3.16427 6.78762 2.82305 7.18805L1.86575 8.31138C1.60032 8.6228 1.60032 9.08096 1.86575 9.39238L2.82305 10.5157C3.16427 10.9161 3.37047 11.414 3.41235 11.9384L3.52975 13.4096C3.56229 13.8175 3.88622 14.1415 4.29416 14.174L5.76536 14.2915C6.28975 14.3333 6.78764 14.5395 7.18806 14.8808L8.31139 15.838C8.62289 16.1035 9.08097 16.1035 9.39239 15.838L10.5158 14.8807C10.9161 14.5395 11.414 14.3333 11.9384 14.2915L13.4096 14.174C13.8176 14.1415 14.1416 13.8175 14.1741 13.4096L14.2915 11.9384C14.3333 11.414 14.5395 10.9161 14.8808 10.5158L15.8381 9.39238C16.1036 9.08096 16.1035 8.62288 15.8381 8.31138L14.8807 7.18805C14.5395 6.78762 14.3333 6.28979 14.2915 5.76538L14.1741 4.29414C14.1416 3.88621 13.8176 3.56229 13.4096 3.52973L11.9384 3.41233C11.4141 3.37049 10.9161 3.16426 10.5157 2.82303L9.39239 1.86573ZM11.2087 5.31645L12.3872 6.49496L6.49467 12.3875L5.31617 11.209L11.2087 5.31645ZM7.37856 7.3788C6.8904 7.86696 6.09895 7.86696 5.61079 7.3788C5.12263 6.89071 5.12263 6.09923 5.61079 5.61107C6.09895 5.12291 6.8904 5.12291 7.37856 5.61107C7.86672 6.09923 7.86672 6.89071 7.37856 7.3788ZM10.3248 12.0929C10.813 12.581 11.6044 12.581 12.0926 12.0929C12.5807 11.6047 12.5807 10.8133 12.0926 10.3251C11.6044 9.83696 10.813 9.83696 10.3248 10.3251C9.83664 10.8133 9.83664 11.6047 10.3248 12.0929Z" fill="#007D23" />
                    </svg>
                    <span className="vocTitle">{offer?.vouDesc}</span>
                    <span className="removeOfrbtn applyofr" onClick={() => applyOfferApi(offer)}>{payDetailLoading ? "Processing..." : "Apply"}</span>
                    {/* <span className="removeOfrbtn applyofr" onClick={() => handleRemove(appliedOffer)}>Apply</span> */}
                    {/* <span className="removeOfrbtn applyofr" onClick={() => handleRemove(appliedOffer)}>Remove</span> */}
                </div>
            </div>
            {/* Show loading indicator if needed */}
            {/* {loading && <div className="text-center">Applying Offer...</div>} */}

            {/* SweetAlert Utility */}
            <SweetAlertUtility
                type={alertDetails.type}
                title={alertDetails.title}
                message={alertDetails.message}
                show={alertDetails.show}
                onConfirm={hideAlert}
            />
        </>
    );
};

export default ApplyOffers;
